@if (groups.length) {
    <ms-scroll-adapter [scrollItems]="scrollItems" [class.parlay-builder]="isMobile()">
        <ul class="market-groups-pills">
            @for (item of groups; track item.id) {
                <li>
                    <button
                        ds-pill
                        msThemedPills
                        size="small"
                        [themedInverse]="themeInverseIndicator"
                        [selected]="!!item.active"
                        (click)="eventSelected(item)">
                        {{ item.title }}
                    </button>
                </li>
            }
        </ul>
    </ms-scroll-adapter>
}
